import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseToastContainerTokens = {
    DEFAULT_BOTTOM_OFFSET: CFTokens.SPACER.E,
    GAP_SIZE: CFTokens.SPACER.B,
};
//
// Helpers
//
export const CFBaseToastContainerHelpers = {
    bottom: ({ bottomOffset }) => {
        return bottomOffset
            ? bottomOffset
            : CFBaseToastContainerTokens.DEFAULT_BOTTOM_OFFSET;
    },
};
//
// Element Styles
//
export const CFBaseToastContainerStyles = {
    Root: css `
    padding: 0 ${CFTokens.SPACER.D}px;
    display: flex;
    flex-direction: column-reverse;
    gap: ${CFBaseToastContainerTokens.GAP_SIZE}px;
    position: absolute;
    right: 0;
    bottom: ${CFBaseToastContainerHelpers.bottom}px;
    left: 0;
    z-index: 1000;
  `,
};
